import { useAuth0 } from '@auth0/auth0-react'

type Role = 'admin' | 'operator' | 'user'

const NAMESPACE = import.meta.env.VITE_AUTH0_NAMESPACE ?? 'https://hub.tesset.com/'

export function useRoles(): Role[] {
  const { user } = useAuth0()
  if (!user) return []
  const roles = (user[`${NAMESPACE}roles`] ?? []) as Role[]
  return roles
}

export function useHasRole(...requiredRoles: Role[]): boolean {
  const roles = useRoles()
  return roles.some((role) => requiredRoles.includes(role))
}
